import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, MenuOptions, MenuItem, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit, leadStatusConfig } from "../../Config";
import { MdOutlineEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { IoMdMore } from "react-icons/io";
import { FaFemale, FaMale, FaUser } from "react-icons/fa";
import { getLeadRentRange, getLeadSource, handleCopy, truncateText } from "../../helpers"
import moment from "moment";
import { FaLink } from "react-icons/fa";
import { IoCopySharp } from "react-icons/io5";

const Table = ({
    apiData,
    setIsShowEditLead,
    setSelectedData,
    setLinkProperty,
    setViewDetail,
    setIsAssignStaff,
    handleAssignProperty,
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const edit = (item) => {
        setIsShowEditLead(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const linkUnlink = (item) => {
        setLinkProperty(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const assignStaff = (item) => {
        setIsAssignStaff(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const viewDetail = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        <MenuItem
                            title="View Lead"
                            onClick={() => viewDetail(item)}
                        >
                            <MdOutlineRemoveRedEye className="text-gray-700 " /> View Lead
                        </MenuItem>
                        {item.status != Config.LEAD_STATUS.CONVERTED &&
                            <>
                                <MenuItem
                                    title="Edit Lead"
                                    onClick={() => {
                                        edit(item);
                                    }}
                                >
                                    <MdOutlineEdit className="text-gray-700 " /> Edit Lead
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        linkUnlink(item)
                                    }}
                                >
                                    <FaLink className="text-gray-700 " /> Link - Unlink
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        assignStaff(item)
                                    }}
                                >
                                    <FaUser className="text-gray-700 " /> Assign Staff
                                </MenuItem>
                            </>
                        }

                    </MenuOptions>
                )
                }
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper >
        );
    };
    useEffect(() => {
        if (apiData) {

            const tempData = apiData.map((item) => ({
                // mobileNo: item.mobileNo,
                //__raw: item,
                visitDate: <span className='text-gray-600 text-sm'>{item.visitDate}</span>,
                visitTime: <span className='text-gray-600 text-sm'>{item.visitTime}</span>,
                name: getName(item),
                rentRange: getLeadRentRange(item.rentRange),
                source: getLeadSource(item.source),
                // property: item.property,
                gender: getGender(item.gender),
                status: getStatus(item),
                action: ActionBtns(item),
                description: item.description,
                date: getDate (item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getStatus = (item) => {
        const config = leadStatusConfig[item.status] || {
            label: "Other",
            color: "text-gray-500",
        };

        return (
            <div className="flex flex-col gap-0.5">
                <span className={`text-sm font-semibold cursor-pointer ${config.color}`} onClick={() => viewDetail(item)}>
                    {config.label}
                </span>
                {(item?.status === Config.LEAD_STATUS.INTERESTED || item?.status === Config.LEAD_STATUS.PAID_TOKEN) &&
                    <button
                        type="button"
                        onClick={() => handleAssignProperty(item)}
                        className="text-xs text-blue-600 hover:text-blue-700 hover:underline text-left w-fit"
                    >
                        Assign Property & Room
                    </button>
                }
                {config.showVisitDate && item.visitDateTime && (
                    <div className="text-xs text-gray-500">
                        {moment(item.visitDateTime).format("DD MMM YY, hh:mm A")}
                    </div>
                )}
            </div>
        );
    };

    const getDate = (item) => {
        const date = moment(item?.createdAt);

        return (
            <div className="flex items-center">
                <div className="flex flex-col px-1 py-2 rounded-2xl duration-200">
                    {/* Date */}
                    <span className="text-sm text-gray-600 tracking-tight">
                        {date.format("DD MMM YYYY")}
                    </span>

                    {/* Time */}
                    <div className="flex items-center gap-1 mt-0.5">
                        <span className="text-xs uppercase tracking-widest text-gray-400">
                            {date.format("hh:mm A")}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const getName = (item) => {
        return (
            <UserImageWrapper onClick={() => viewDetail(item)} className='cursor-pointer'>
                {item.gender === 1 ? (
                    <FaMale className="text-gray-400 w-8 h-8" />
                ) : (
                    <FaFemale className="text-gray-400 w-8 h-8" />
                )}
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {item?.name?.charAt(0).toUpperCase() + item?.name?.slice(1)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item?.mobile || truncateText(item?.email, 20)}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item?.mobile || item?.email);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };


    const getGender = (gender) => {
        if (gender === 1) {
            return <p>Male</p>;
        } else if (gender === 2) {
            return <p>Female</p>;
        }
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Rent Range",
                    accessor: "rentRange",
                },
            ];
        }
        return [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Rent Range",
                accessor: "rentRange",
            },
            {
                Header: "Source",
                accessor: "source",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Date",
                accessor: "date",
            },

            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        const isActionColumn = cell.column.id === "action";
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {typeof cell.value === "function"
                                                    ? cell.value()  // render dynamic function
                                                    : cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Gender:</strong> {row.original.gender === 1 ? "Male" : "Female"}
                                                </li>
                                                <li>
                                                    <strong>Rent Range:</strong>{" "}
                                                    {getLeadRentRange(row.original.rentRange)}
                                                </li>
                                                <li>
                                                    <strong>Source:</strong> {getLeadSource(row.original.source)}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Status:</strong> {row.original.status}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Date:</strong> {row.original.date}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {row.original.action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};
const UserImageWrapper = tw.div` flex items-center gap-2`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;

export default Table;

